import React, { useState, useEffect } from "react";
import FacultyNavbar from './FacultyNavbar'; // Import FacultyNavbar

const Saved = () => {
  const [savedStudents, setSavedStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);

  useEffect(() => {
    try {
      const students = JSON.parse(localStorage.getItem("savedStudents")) || [];
      setSavedStudents(students);
      setFilteredStudents(students);
    } catch {
      setSavedStudents([]);
      setFilteredStudents([]);
    }
  }, []);

  const removeStudent = (rollNumber) => {
    const updatedStudents = savedStudents.filter(
      (student) => student.rollNumber !== rollNumber
    );
    setSavedStudents(updatedStudents);
    setFilteredStudents(updatedStudents);
    localStorage.setItem("savedStudents", JSON.stringify(updatedStudents));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const lowerCaseSearch = searchTerm.toLowerCase();
    const results = savedStudents.filter(
      (student) =>
        student.rollNumber.toLowerCase().includes(lowerCaseSearch) ||
        student.fullName.toLowerCase().includes(lowerCaseSearch)
    );
    setFilteredStudents(results);
  };

  const toggleDetails = (index) => {
    setFilteredStudents((prev) =>
      prev.map((student, i) =>
        i === index
          ? { ...student, showDetails: !student.showDetails }
          : student
      )
    );
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <FacultyNavbar /> {/* Add FacultyNavbar here */}
      <div className="container mx-auto mt-8">
        <h2 className="text-center text-2xl font-bold mb-6">Saved Students</h2>
        <form
          className="flex flex-col sm:flex-row items-center gap-4 mb-6"
          onSubmit={handleSearch}
        >
          <input
            className="w-full sm:w-auto px-4 py-2 border rounded-md shadow-sm"
            type="search"
            placeholder="Search by name or roll number"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            type="submit"
            className="px-6 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700"
          >
            Search
          </button>
        </form>
        <div className="flex flex-wrap justify-center gap-6">
          {/* Add a check to ensure filteredStudents is an array */}
          {Array.isArray(filteredStudents) && filteredStudents.length > 0 ? (
            filteredStudents.map((student, index) => (
              <div
                key={student.rollNumber}
                className="w-full sm:w-80 bg-white border rounded-lg shadow-md p-4"
              >
                <img
                  src="https://via.placeholder.com/100"
                  alt="Profile"
                  className="w-24 h-24 mx-auto rounded-full mb-4"
                />
                <div className="text-center">
                  <h5 className="text-lg font-semibold mb-2">{student.fullName}</h5>
                  <p className="text-sm text-gray-600">Roll Number: {student.rollNumber}</p>
                  <p className="text-sm text-gray-600">Class: {student.classSection}</p>
                  <p>
                    Eligibility:{" "}
                    <span
                      className={`font-bold ${
                        student.isEligible ? "text-green-500" : "text-red-500"
                      }`}
                    >
                      {student.isEligible ? "Eligible" : "Not Eligible"}
                    </span>
                  </p>
                  <div className="mt-2 flex flex-wrap justify-center gap-2">
                    {student.skills && student.skills.map((skill, i) => (
                      <span
                        key={i}
                        className="bg-gray-200 text-gray-800 text-xs px-2 py-1 rounded-full"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                  <div className="mt-4 space-y-2">
                    <button
                      onClick={() => removeStudent(student.rollNumber)}
                      className="w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                    >
                      Remove
                    </button>
                    <button
                      onClick={() => toggleDetails(index)}
                      className="w-full py-2 bg-blue-100 text-blue-600 rounded-md hover:bg-blue-200"
                    >
                      {student.showDetails ? "View Less" : "View More"}
                    </button>
                  </div>
                  {student.showDetails && (
                    <div className="mt-4 text-left text-sm">
                      <p>Email: {student.email}</p>
                      <p>Phone: {student.phoneNumber}</p>
                      <p>Department: {student.department}</p>
                      <p>Portfolio: {student.portfolio}</p>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-600">No students found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Saved;
